/* eslint-disable import/prefer-default-export */
import tailwindConfig from 'tailwind.config.js';

export function config() {
  return tailwindConfig;
}

export function theme() {
  return tailwindConfig.theme;
}

export function breakpointSize(name: keyof ReturnType<typeof theme>['screens']) {
  return parseInt(theme().screens[name], 10);
}
